import enquire from 'enquire.js'
import { queries } from './config'

export default function withMedia(Component) {
    return class extends Component {
        constructor(element) {
            super(element)

            if (!('media' in this.options)) {
                this.options.media = ''
            }

            if (this.element.dataset.media) {
                this.options.media = this.element.dataset.media
            }

            if (this.options.media) {
                this.options.media =
                    this.options.media in queries ? queries[this.options.media] : this.options.media
            }

            this.enquireHandler = {
                match: () => super.prepare(),
                unmatch: () => super.destroy(),
            }
        }

        prepare() {
            if (this.options.media) {
                enquire.register(this.options.media, this.enquireHandler)
            } else {
                super.prepare()
            }
        }

        destroy() {
            if (this.options.media) {
                enquire.unregister(this.options.media, this.enquireHandler)
            } else {
                super.destroy()
            }
        }
    }
}
